import client from '../client';

export const progixApis = {
  getProgixUser: (page: number, size: number, searchType: string, keyword: string) =>
    client.get(`/progix?size=${size}&page=${page}&sortBy=customerCode&isAsc=true&searchType=${searchType}&keyword=${keyword}`),
  getProgixOrderList: ({
    searchType,
    searchWord,
    page,
    size,
    statusCd,
  }: {
    searchType: string;
    searchWord: string;
    page: number;
    size: number;
    statusCd: number;
  }) =>
    client.get(
      `/progix/ordersheet/list?searchType=${searchType}&keyword=${searchWord}&limit=${size}&page=${page}&statuscd=${statusCd}`,
    ),
  postProgixRefund: (data: { impUid: string; amount: number }) => client.post(`/progix/payment/refundaccept`, data),
};
